/**
 * LotteryShared - 抽奖组件共享子组件和类型
 *
 * 提供所有抽奖组件（WheelLottery, ProductLottery 等）共用的子组件和类型定义。
 *
 * @module LotteryShared
 * @date 2026-04-07
 */

// ============================================================================
// 共享子组件导出
// ============================================================================

export { BaseModal } from './BaseModal.js'
export { PrizePool } from './PrizePool.js'
export { ChanceMethods } from './ChanceMethods.js'
export { WinnerModal } from './WinnerModal.js'
export { RulesModal } from './RulesModal.js'
export { MyRewardsModal } from './MyRewardsModal.js'
export { ErrorModal } from './ErrorModal.js'
export { ShareModal } from './ShareModal.js'

// ============================================================================
// 共享类型导出
// ============================================================================

export type {
  // 核心实体类型
  Prize,
  WinningInfo,
  ChanceMethod,
  ChanceMethodType,
  ChanceMethodStatus,
  UserData,
  EasingFunction,
  Theme,
  Img,

  // 公共文案配置类型
  CopyTextConfig,
  CouponConfig,
  PrizeTimeTextConfig,

  // 弹窗配置类型
  WinnerModalConfig,
  RulesModalConfig,
  MyRewardsModalConfig,
  ErrorModalConfig,
  ShareModalConfig,
  SharePlatformConfig,
  SocialPlatform,

  // 子组件 Props 类型
  PrizePoolProps,
  ChanceMethodsProps,
  ChanceMechanismType,
  ChanceInputConfig,
  WinnerModalProps,

  // 回调类型别名
  OnSpinEndCallback,
  OnChanceMethodClick,
} from './types.js'

// 子组件自定义类型
export type { BaseModalProps } from './BaseModal.js'
export type { RulesModalProps, RuleItem } from './RulesModal.js'
export type { MyRewardsModalProps, Reward, RewardStatus } from './MyRewardsModal.js'
export type { ErrorModalProps } from './ErrorModal.js'
export type { ShareModalProps } from './ShareModal.js'

// ============================================================================
// 共享常量和工具函数导出
// ============================================================================

export { DEFAULT_CHANCE_METHODS, isPrize, isChanceMethod, isWinningInfo } from './types.js'
